import { render, staticRenderFns } from "./trigger-view.vue?vue&type=template&id=45d89483&"
import script from "./trigger-view.vue?vue&type=script&lang=js&"
export * from "./trigger-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports